export { default } from './SettingsNewEmployee.jsx';
